import createRoute   from '@widesk-ui/tools/createRoute';
import SitePageModel from '@models/admin/SitePageModel';

export default createRoute.dashboard(
	SitePageModel.pagePath('list'),
	SitePageModel.serviceName,
	'SitePageDashboard',
	SitePageModel.localize(),
);